/**
 * FilterParam - Фильтр на параметрическом, связывается с FilerPopup
 */

import AdditionFilters from '../addition-filters';
import MultiSelect from 'components/forms/multi-select';
import Observer from 'common/scripts/mediator';
import RangeSlider from 'components/range-slider';
import Utils from 'common/scripts/utils';

const observer = new Observer();

class FilterParam {
    constructor(options) {
        this.options = options;
        this.containerSelector = '.j-filter-param';
        this.container = options.wrapper ? options.wrapper.querySelector(this.containerSelector) : null;
        this.featureSelector = '.j-multi-select-feature';
        this.priceSelector = '.j-range-price';
        this.paySelector = '.j-range-pay';
        this.areaSelector = '.j-range-area';
        this.roomSelector = '.j-filter-param-room';
        this.toggleSelector = '.j-filter-param-toggle';
        this.submitSelector = '.j-filter-param-result';
        this.fixWrapperSelector = '.j-filter-param-fix';
        this.countdownSelector = '.j-countdown';

        this.lastScrollTop = 0;
        this.scrollDirection = 'down';

        this.init();
    }

    init() {
        if (!this.container) {
            return;
        }

        this._initElements();
        this._initMultiSelect();
        this._iniRangeSliders();
        this._initAdditionFilter();
        this._checkFixInTop();
        this._bindEvents();
    }

    _initElements() {
        this.toggles = Array.from(document.querySelectorAll(this.toggleSelector));
        this.rooms = Array.from(this.container.querySelectorAll(this.roomSelector));

        this.submit = this.container.querySelector(this.submitSelector);

        this.fixWrapper = this.container.querySelector(this.fixWrapperSelector);
        this.countdown = document.querySelector(this.countdownSelector);
    }

    _initMultiSelect() {
        this.features = new MultiSelect({
            container  : this.featureSelector,
            afterChange: (val) => {
                observer.publish('filter-param:features', val);

                this._send();
            }
        });

        this.features.init();
    }

    _iniRangeSliders() {
        if (document.querySelector(this.priceSelector)) {
            this.price = new RangeSlider();

            this.price.init({
                name    : 'parametricPrice',
                wrapper : this.priceSelector,
                onFinish: (val) => {
                    observer.publish('filter-param:price', {
                        ...val,
                        double: false
                    });

                    this._send();
                }
            });
        }

        if (document.querySelector(this.paySelector)) {
            this.pay = new RangeSlider();

            this.pay.init({
                name    : 'parametricPay',
                wrapper : this.paySelector,
                onFinish: (val) => {
                    observer.publish('filter-param:pay', {
                        ...val,
                        double: false
                    });

                    this._send();
                }
            });
        }

        if (document.querySelector(this.areaSelector)) {
            this.area = new RangeSlider();

            this.area.init({
                name    : 'parametricArea',
                wrapper : this.areaSelector,
                onFinish: (val) => {
                    observer.publish('filter-param:area', {
                        ...val,
                        double: true
                    });

                    this._send();
                }
            });
        }
    }

    _initAdditionFilter() {
        this.additionFilter = new AdditionFilters({wrapper: this.container});
    }

    _bindEvents() {
        this.toggles.forEach((toggle) => {
            toggle.addEventListener('click', () => {
                if (this.options.clickShowAll) {
                    this.options.clickShowAll();
                }
            });
        });

        this.rooms.forEach((room) => {
            room.addEventListener('change', () => {
                const checked = this.rooms.filter((item) => {
                    return item.checked;
                });
                const values = checked.map((item) => {
                    return item.value;
                });

                observer.publish('filter-param:rooms', values);
                this._send();
            });
        });

        this.submit.addEventListener('click', this.options.clickSubmit);

        observer.subscribe('filter-popup:features', (val) => {
            this.features.setVal(val);
        });

        observer.subscribe('filter-popup:price', (val) => {
            this.price.setValues(val);
        });

        observer.subscribe('filter-popup:pay', (val) => {
            if (this.pay) {
                this.pay.setValues(val);
            }
        });

        observer.subscribe('filter-popup:area', (val) => {
            this.area.setValues(val);
        });

        observer.subscribe('filter-popup:rooms', (val) => {
            this.setRooms(val);
        });

        observer.subscribe('filter-popup:change-tab', (name) => {
            this._priceOrPay(name);
        });

        observer.subscribe('removeCountdown', () => {
            this._checkFixInTop(this.scrollDirection);
        });

        window.addEventListener('scroll', this._scrollWindow.bind(this));
        window.addEventListener('resize', Utils.debounce(this._checkFixInTop.bind(this), 100));
    }

    _scrollWindow() {
        if (window.pageYOffset > this.lastScrollTop) {
            this.scrollDirection = 'down';
        } else {
            this.scrollDirection = 'up';
        }

        this.lastScrollTop = window.pageYOffset <= 0 ? 0 : window.pageYOffset;

        this._checkFixInTop(this.scrollDirection);
    }

    setRooms(values = []) {
        this.rooms.forEach((room) => {
            room.checked = values.indexOf(room.value) !== -1;
        });
    }

    _send() {
        if (this.options.afterChange) {
            this.options.afterChange();
        }
    }

    _priceOrPay(name) {
        if (name === 'price') {
            this.price.enabled();
        } else {
            this.price.disabled();
        }
    }

    replaceSubmitText(text, tinyText) {
        const textEl = this.submit.querySelector('.btn__text');
        const textTinyEl = this.submit.querySelector('.btn__text-tiny');

        Utils.clearHtml(textEl);
        Utils.insetContent(textEl, text);

        if (tinyText && textTinyEl) {
            Utils.clearHtml(textTinyEl);
            Utils.insetContent(textTinyEl, tinyText);
        }
    }

    _checkFixInTop(direction = 'down') {
        if (window.innerWidth < 1280) {
            this.container.removeAttribute('style');
            this._offFixTop();

            return;
        }

        const top = this.container.getBoundingClientRect().top;

        if (top < -this.container.offsetHeight) {
            this.container.style.height = `${this.container.offsetHeight}px`;

            if (direction === 'down') {
                this._fixTopHide();
            } else {
                this._fixTopShow();
            }
            this._onFixTop();
        } else if (top > 0) {
            this.container.removeAttribute('style');
            this._offFixTop();
        }
    }

    _onFixTop() {
        this.fixWrapper.classList.add('fix-top');

        if (this.countdown) {
            this._checkCountdown();
        }
    }

    _offFixTop() {
        this.fixWrapper.classList.remove('fix-top');

        if (this.countdown && !this.countdown.classList.contains('is-hide')) {
            this._offFixTransform();
        }
    }

    _fixTopShow() {
        this.fixWrapper.classList.remove('is-hide');
    }

    _fixTopHide() {
        this.fixWrapper.classList.add('is-hide');
    }

    _checkCountdown() {
        if (this.countdown.classList.contains('is-hide')) {
            this._offFixTransform();
        } else {
            this._onFixTransform();
        }
    }

    _offFixTransform() {
        this.fixWrapper.style.transform = `translateY(0)`;
    }

    _onFixTransform() {
        const height = `${this.countdown.offsetHeight}px`;

        this.fixWrapper.style.transform = `translateY(${height})`;
    }

    disableButton() {
        this.submit.classList.add('is-disabled');
    }

    enableButton() {
        this.submit.classList.remove('is-disabled');
    }
}

export default FilterParam;
